var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpsRatingLikely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5044 69.8701H66.7641C68.211 69.8701 69.3789 68.7022 69.3789 67.2554C69.3789 65.8086 68.211 64.6406 66.7641 64.6406H33.5044C32.0576 64.6406 30.8897 65.8086 30.8897 67.2554C30.8897 68.7022 32.0576 69.8701 33.5044 69.8701Z",
    fill: "#3B6CCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2391 45.5562C65.0119 45.4711 62.4647 42.786 62.5498 39.5588C62.6348 36.3315 65.32 33.7843 68.5472 33.8694C71.7744 33.9545 74.3217 36.6396 74.2366 39.8668C74.1515 43.0941 71.4664 45.6413 68.2391 45.5562Z",
    fill: "#3B6CCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6155 45.5424C28.3872 45.5424 25.7701 42.9253 25.7701 39.697C25.7701 36.4687 28.3872 33.8516 31.6155 33.8516C34.8438 33.8516 37.4609 36.4687 37.4609 39.697C37.4609 42.9253 34.8438 45.5424 31.6155 45.5424Z",
    fill: "#3B6CCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.5712 100 100 77.5712 100 50C100 22.4288 77.5712 0 50 0C22.4288 0 0 22.4288 0 50C0 77.5712 22.4288 100 50 100ZM50 5.23533C74.6833 5.23533 94.7705 25.3167 94.7705 50.0058C94.7705 74.6949 74.6891 94.7763 50 94.7763C25.3109 94.7763 5.22952 74.6949 5.22952 50.0058C5.22952 25.3167 25.3109 5.23533 50 5.23533Z",
    fill: "#3B6CCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsRatingLikely);
export default __webpack_public_path__ + "static/media/nps-rating-likely.41936de8d7242a041a8467db88bd0945.svg";
export { ForwardRef as ReactComponent };